import React from 'react';
import { useReviews } from '../../Hooks/useReviews';
import './ReviewCarousel.css';

const ReviewCarousel = () => {
  const { reviews } = useReviews();

  const renderStars = (rating) => {
    return Array.from({ length: 5 }, (_, index) => (
      <span 
        key={index} 
        className={`star ${index < rating ? 'filled' : ''}`}
      >
        ★
      </span>
    ));
  };

  return (
    <div className="review-container">
      <div className="review-header">
        <h2>What Our Customers Say</h2>
        <p>Read testimonials from our satisfied customers</p>
      </div>
      
      <div className="review-scroll-container">
        <div className="review-cards-wrapper">
          {reviews.map((review) => (
            <div key={review.id} className="review-card">
              <div className="review-background">
                <img src={review.image} alt={`Review by ${review.name}`} loading="lazy" />
              </div>
              <div className="review-overlay">
                <div className="review-name">{review.name}</div>
                {/* <div className="review-title">{review.title}</div> */}
                <div className="review-rating">
                  {renderStars(review.rating)}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ReviewCarousel;
